module.exports = __webpack_public_path__ + "static/media/mcompERP.9470a573.png";